import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataService } from '../services/auth-data.service';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(
    private authDataService: AuthDataService,
    private tokenService: TokenService,
    private router: Router
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.authDataService.getToken();

    if (token) {
      this.router.navigate(['/dashboard']);
      const tokenPayload = this.tokenService.decodeToken(token);

      const expirationDate = new Date((tokenPayload.exp || 0) * 1000);
      if (new Date() >= expirationDate) {
        this.authDataService.logout();
        return true;
      }
      return true;
    }
    return true;
  }
}
